import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';


import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Admin from './pages/Admin';
import Reminder, {loader as reminderLoader} from './pages/Reminder';


const router = createBrowserRouter([
    {
      path: "/",
      element: <App />
    },
    {
        path: "/admin",
        element: <Admin />
    },
    {
        path: "/reminders/:taskId",
        element: <Reminder />,
        loader: reminderLoader
    }
  ]);

const rootElement = document.getElementById('root') as Element;
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
    <RouterProvider router={router} />
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

